module.exports = __webpack_public_path__ + "img/empty.70dfc788.png";